import { FC, Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectMapCultures } from '../../../../slice/selectors';
import { useTranslation } from 'react-i18next';
import { useMapSlice } from '../../../../slice';
import MapMenu, { MapMenuRow } from 'app/components/MapMenu/MapMenu';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import * as S from './CulturesMenu.styles';

interface IProps {}

const CulturesMenu: FC<IProps> = () => {
  const { t } = useTranslation();

  const { actions } = useMapSlice();
  const dispatch = useDispatch();

  const mapCultures = useSelector(selectMapCultures);

  const [activeDropdownCulturesIds, setActiveDropdownCulturesIds] = useState<
    number[]
  >([]);

  const onCultureClick = (cultureId: number) => {
    dispatch(actions.toggleCultureMenuSelectedId(cultureId));
  };

  const onVariationClick = (variationId: number) => {
    dispatch(actions.toggleCultureMenuSelectedVariationId(variationId));
  };

  const onDropdownIconClick = (cultureId: number) => {
    setActiveDropdownCulturesIds(prevState => {
      if (prevState.includes(cultureId)) {
        return prevState.filter(id => cultureId !== id);
      } else {
        return [...prevState, cultureId];
      }
    });
  };

  return (
    <MapMenu title={t('Map.Cultures', 'Cultures')}>
      {mapCultures.map(culture => (
        <Fragment key={culture.cultureName}>
          <MapMenuRow>
            <S.Part>
              <S.CultureDropdownIcon
                $disabled={!culture.cultureVariations.length}
                $active={Boolean(
                  culture.cultureVariations.length &&
                    activeDropdownCulturesIds.includes(culture.cultureId),
                )}
                onClick={() => onDropdownIconClick(culture.cultureId)}
              />

              <Checkbox
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  onCultureClick(culture.cultureId);
                }}
                key={culture.cultureName}
                checked={culture.isSelected}
              >
                {culture.cultureName ||
                  t('Common.WithoutCulture', 'Without culture')}
              </Checkbox>

              <S.CultureColorCircle $color={culture.cultureColor} />
            </S.Part>

            <S.CheckboxRowAreaPart>{culture.area}</S.CheckboxRowAreaPart>
          </MapMenuRow>
          <S.VariationsContainer
            $active={Boolean(
              culture.cultureVariations.length &&
                activeDropdownCulturesIds.includes(culture.cultureId),
            )}
          >
            {culture.cultureVariations.map(variation => (
              <MapMenuRow
                key={variation.cultureVariation.id}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  onVariationClick(variation.cultureVariation.id);
                }}
              >
                <S.Part style={{ marginLeft: 45 }}>
                  <Checkbox
                    disabled={!culture.isSelected}
                    checked={culture.isSelected && variation.isSelected}
                  >
                    {variation.cultureVariation.name}
                  </Checkbox>
                </S.Part>

                <S.CheckboxRowAreaPart>{variation.area}</S.CheckboxRowAreaPart>
              </MapMenuRow>
            ))}
          </S.VariationsContainer>
        </Fragment>
      ))}
    </MapMenu>
  );
};

export default CulturesMenu;
